import React, { useState } from "react";
import PropTypes from "prop-types";
import { ServiceWrapper } from "@cars24/turbo-web/lib/service-wrapper";
import { Modal } from "@cars24/turbo-web/lib/modal";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import styles from "./styles.css";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { MORE_TAB_LABEL, getPrimaryServices } from "./selector";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import CloseButton from "../../shared/icon-cross";

const RtoVehInfoServiceList = ({
    cmsImageGallery
}) => {
    const { services } = cmsImageGallery || {};
    const { tokens } = useTokens();
    const primaryServices = getPrimaryServices(services);
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    };

    const onClick = async (label) => {
        if (label === MORE_TAB_LABEL) {
            setIsOpen(true);
        }
        await yieldToMain();
        sendCustomGaEvents({
            event: "super_home_page",
            eventCategory: "super_home_page",
            eventAction: "top_businesses_clicked",
            eventLabel: label
        });
    };

    if ((services || []).length === NUMBER.ZERO) return null;

    return (
        <div styleName={"styles.rtoVehInfoServiceList"}>
            <Heading level={NUMBER.FOUR}>Other services</Heading>
            <div styleName={"styles.serviceWrapper"}>
                <ServiceWrapper list={primaryServices} onClick={onClick}/>
            </div>

            {
                isOpen &&
                <Modal
                    showCloseButton={false}
                    isOpen={isOpen}
                    overlayColor={tokens.background_surface_overlay_primary}
                    width={"980px"}
                    height={"400px"}
                    onClose={handleClose}
                >
                    <div styleName={"styles.modalWrapper"}>
                        <div styleName={"styles.modalHeader"}>
                            <Heading level={NUMBER.FOUR}>Our services</Heading>
                            <CloseButton onClickHandler={handleClose} />
                        </div>
                        <div styleName={"styles.serviceWrapper styles.modalServices"}>
                            <ServiceWrapper list={services} onClick={onClick}/>
                        </div>
                    </div>
                </Modal>
            }
        </div>
    );
};

RtoVehInfoServiceList.propTypes = {
    cmsImageGallery: PropTypes.object
};

export default RtoVehInfoServiceList;
